import { render, staticRenderFns } from "./PhotoReviewClientView.vue?vue&type=template&id=8963ac3e&scoped=true&"
import script from "./PhotoReviewClientView.vue?vue&type=script&lang=js&"
export * from "./PhotoReviewClientView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoReviewClientView.vue?vue&type=style&index=0&id=8963ac3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8963ac3e",
  null
  
)

export default component.exports